import { Box, Paper, Tooltip, Typography } from '@mui/material'
import { ActionIconButton } from '../../../../../../components/ActionIconButton/ActionIconButton'
import UpdateIcon from '@mui/icons-material/Update'
import React from 'react'
import { IGame } from '../../../../../../api/types/game'
import { useInvalidatingMutation } from '../../../../../../hooks/useInvalidatingMutation'
import { AxiosResponse } from 'axios'
import { mutationPassTime } from '../../../../../../api/mutations'
import {
  characterEffectsQueryKey,
  gameCharsQueryKey,
  gameQueryKey,
} from '../../../../../../api/queries'

export const TimeControl: React.FC<{ game: IGame }> = ({ game }) => {
  const { mutate, isLoading } = useInvalidatingMutation<AxiosResponse, IGame>(
    game => mutationPassTime(game),
    [gameQueryKey(game.slug), ['character_effects'], gameCharsQueryKey(game.id)]
  )

  return (
    <>
      <Paper
        sx={{
          marginLeft: '4px',
          marginRight: '4px',
          marginBottom: '8px',
          padding: '8px',
        }}
      >
        <Typography color="text.secondary" variant="caption" display="block" gutterBottom>
          Czas
        </Typography>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
          }}
        >
          <Box>Upłynęło {game.time} jednostek</Box>
          <Box>
            <ActionIconButton disabled={isLoading} onClick={() => mutate(game)}>
              <Tooltip title="Upływ czasu o 1 jednostkę">
                <UpdateIcon />
              </Tooltip>
            </ActionIconButton>
          </Box>
        </Box>
      </Paper>
    </>
  )
}
